import { IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';

const NON_CACHEABLE_TYPENAMES = Object.freeze([
  'lp_ReleaseFormat',
  'OrderCollection',
  'ListingCollection',
]);

function nonCacheable(typename: string): boolean {
  return NON_CACHEABLE_TYPENAMES.indexOf(typename) > -1;
}

export const cacheOptions = {
  fragmentMatcher: new IntrospectionFragmentMatcher({
    introspectionQueryResultData: {
      __schema: {
        types: [
          {
            kind: 'UNION',
            name: 'HydratedFacet',
            possibleTypes: [
              {
                name: 'Brand',
              },
              {
                name: 'Category',
              },
            ],
          },
          {
            kind: 'UNION',
            name: 'FeedEntry',
            possibleTypes: [
              {
                name: 'Article',
              },
              {
                name: 'Listing',
              },
            ],
          },
        ],
      },
    },
  }),
  dataIdFromObject: (result: any) => {
    if (result.__typename) {
      if (nonCacheable(result.__typename)) {
        return null;
      }

      // Check to see if we're selecting a Node type via the naming convention
      // established in RQL. Types like Listing are Nodes, but types like api_messages_Listing
      // are not.
      //
      // Having conflicting or missing IDs for objects can result in failures to write to the apollo
      // cache. Node should _always_ have an _id field.
      if (/^[A-Z]/.test(result.__typename)) {
        if (!result._id) {
          console.error(`A query returned a ${result.__typename} without an _id field. This can cause Apollo to fail to write this object to the cache`);
        }
      }

      if (result._id !== undefined) {
        return `${result.__typename}:${result._id}`;
      }

      if (result.uuid !== undefined) {
        return `${result.__typename}:uuid:${result.uuid}`;
      }

      if (result.id !== undefined) {
        return `${result.__typename}:id:${result.id}`;
      }
    }

    return null;
  },
};
